import { all, call, delay, fork, put, take } from 'redux-saga/effects';

import { checkVersion } from 'modules/app/actions';
import { CHECK_VERSION_FAILURE, CHECK_VERSION_REQUEST, CHECK_VERSION_SUCCESS } from 'modules/app/actionTypes';
import type { SimpleRequestConfig } from 'modules/app/types';
import { simpleRequestsLoader } from 'modules/app/utils';
import type { AppMeta } from 'modules/app/versionUtils';
import { getNightlyCheckAt, shouldReloadApp } from 'modules/app/versionUtils';
import { isApiFailure } from 'modules/global/generic.guards';
import type { PutAndWaitResult } from 'modules/global/generic.types';

import packageJson from '../../../../package.json';

const { version: CURRENT_VERSION } = packageJson;

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

function* pollVersion() {
  let nightlyCheckAt = getNightlyCheckAt();

  while (true) {
    yield delay(POLL_INTERVAL_MS);

    yield put(checkVersion());
    const result: PutAndWaitResult<AppMeta> = yield take([CHECK_VERSION_SUCCESS, CHECK_VERSION_FAILURE]);
    const appVersions = isApiFailure(result) ? null : result.payload;
    const isNightlyCheck = Date.now() >= nightlyCheckAt.getTime();

    if (appVersions && shouldReloadApp(CURRENT_VERSION, appVersions, isNightlyCheck)) {
      yield call([window.location, 'reload']);
      return;
    }

    if (appVersions && isNightlyCheck) {
      nightlyCheckAt = getNightlyCheckAt();
    }
  }
}

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [CHECK_VERSION_REQUEST]: { notifications: { failure: () => undefined } },
};

export default function* appSagas() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield fork(pollVersion);
}
